import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Params } from '@angular/router';

export interface Breadcrumb {
    label: string;
    link?: string;
    queryParams?: Params;
}

@Component({
    selector: 'lokos-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BreadcrumbComponent {
    @Input() breadcrumbs: Breadcrumb[] = [];
}
